<template>
  <div>
    <div>
      <div style="margin: 0 0 20px 20px;">
        <span style="font-weight: 500;font-size: 18px;">合同账款</span>
      </div>
      <contract-account
        ref="contractAccountRefs"
        :query-params="queryParamsex"
      ></contract-account>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>付款记录</span>
      </div>

      <el-table
        style="margin-top:20px"
        ref="custromTableRef"
        :data="list"
        tooltip-effect="dark"
        max-height="378"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
        border
      >
        <el-table-column
          prop="supplierPayNumber"
          label="付款编号"
        ></el-table-column>
        <el-table-column
          prop="payModel"
          label="付款方式"
        ></el-table-column>
        <el-table-column
          prop="payMoney"
          label="付款金额"
        ></el-table-column>
        <el-table-column
          prop="pcbCount"
          label="涉及合同"
        ></el-table-column>
        <el-table-column
          prop="initialDueDate"
          label="最初账款到账时间"
          width="140px"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.initialDueDate | dateFilter }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="payState"
          label="付款状态"
        ></el-table-column>
        <el-table-column
          prop="createUser"
          label="提交人"
        ></el-table-column>
        <el-table-column
          prop="createDate"
          label="提交时间"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.createDate | dateFilter }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { formatDate } from '@/util/tool'
import contractAccount from './contractAccount' // 合同账款

export default {
  props: ['queryParams'],
  components: {
    'contract-account': contractAccount
  },
  data () {
    return {
      list: [],
      loadingTable: false,
      queryParamsex: {}
    }
  },
  methods: {
    // 接收数据
    onInitial (val, preview) {
      this.list = val // 付款记录
      // this.$refs.contractAccountRefs.onInitial(preview)
      this.queryParamsex = preview
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  },
  filters: {
    dateFilter
  }
}

function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style
  lang="scss"
  scoped
></style>
